var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tg-post"},[_c('div',{staticClass:"row",staticStyle:{"display":"flex"}},_vm._l((_vm.list),function(book,index){return _c('book',{key:index,staticClass:"col-md-2",attrs:{"book":book}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }